import { create } from 'zustand';

import { User } from '@/slw/entities/chat';

import { useUserStore } from './user-store';

// Define chat store state interface
interface ChatStoreState {
  chatId: string | null;
  user: User | null;
  isOpen: boolean;
  searchChat: string;
  isCurrentUserBlocked: boolean;
  isReceiverBlocked: boolean;
  defaultLayout: number[] | undefined;
  setSearchChat: (searchChat: string) => void;
  changeChat: (chatId: string, user: User) => void;
  changeBlock: () => void;
  resetChat: () => void;
  openChat: () => void;
  closeChat: () => void;
  toggleChat: () => void;
  setDefaultLayout: (layout: number[] | undefined) => void;
}

export const useChatStore = create<ChatStoreState>((set) => ({
  chatId: null,
  user: null,
  isCurrentUserBlocked: false,
  isReceiverBlocked: false,
  isOpen: false,
  searchChat: '',
  defaultLayout: undefined,
  changeChat: (chatId: string, user: User) => {
    const currentUser = useUserStore.getState().currentUser! as User;

    // CHECK IF CURRENT USER IS BLOCKED
    if (user?.blocked?.includes(currentUser.id)) {
      return set({
        chatId,
        user: null,
        isCurrentUserBlocked: true,
        isReceiverBlocked: false,
      });
    }

    // CHECK IF RECEIVER IS BLOCKED
    else if (currentUser?.blocked?.includes(user?.id)) {
      return set({
        chatId,
        user,
        isCurrentUserBlocked: false,
        isReceiverBlocked: true,
      });
    } else {
      return set({
        chatId,
        user,
        isCurrentUserBlocked: false,
        isReceiverBlocked: false,
      });
    }
  },

  changeBlock: () => {
    set((state) => ({ ...state, isReceiverBlocked: !state.isReceiverBlocked }));
  },
  setSearchChat: (searchChat: string) => {
    set((state) => ({ ...state, searchChat }));
  },
  openChat: () => {
    set((state) => ({ ...state, isOpen: true }));
  },
  closeChat: () => {
    set((state) => ({ ...state, isOpen: false }));
  },
  toggleChat: () => {
    set((state) => ({ ...state, isOpen: !state.isOpen }));
  },
  setDefaultLayout: (layout: number[] | undefined) => {
    set((state) => ({ ...state, defaultLayout: layout }));
  },
  resetChat: () => {
    set({
      chatId: null,
      user: null,
      isCurrentUserBlocked: false,
      isReceiverBlocked: false,
      searchChat: '',
      isOpen: false,
      defaultLayout: undefined,
    });
  },
}));
